import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentStep: 1,
  emailOrPhone: '',
  otp: '',
  newPassword: '',
  confirmNewPassword: '',
};

const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setEmailOrPhone: (state, action) => {
      state.emailOrPhone = action.payload;
    },
    setOtp: (state, action) => {
      state.otp = action.payload;
    },
    setNewPassword: (state, action) => {
      state.newPassword = action.payload;
    },
    setConfirmNewPassword: (state, action) => {
      state.confirmNewPassword = action.payload;
    },
    resetForgotPasswordFlow: () => initialState,
  },
});

export const {
  setCurrentStep,
  setEmailOrPhone,
  setOtp,
  setNewPassword,
  setConfirmNewPassword,
  resetForgotPasswordFlow,
} = forgotPasswordSlice.actions;
export default forgotPasswordSlice.reducer;
